<section class="password-panel">
  <header class="password-panel__header">
    <span class="password-panel__eyebrow">Account security</span>
    <h2>{{ hasPassword() ? 'Change password' : 'Create password' }}</h2>
    <p>{{ hasPassword() ? 'Replace your current password with a secure new one.' : 'Add a password to strengthen access to your account.' }}</p>
  </header>

  <form id="change-password-form" class="password-panel__body" [formGroup]="changePasswordForm"
    (ngSubmit)="onFormSubmit()" autocomplete="off">
    <section class="password-summary">
      <div class="password-summary__icon"><mat-icon>shield_lock</mat-icon></div>
      <div>
        <strong>{{ hasPassword() ? 'Secure your account' : 'Set up password access' }}</strong>
        <span>{{ hasPassword() ? 'Changing your password will update how you sign in.' : 'Create a unique password that you do not use elsewhere.' }}</span>
      </div>
    </section>

    <section class="password-section">
      <div class="password-section__heading">
        <mat-icon>key</mat-icon>
        <div>
          <h3>Password details</h3>
          <p>Use a strong, unique password and confirm it carefully.</p>
        </div>
      </div>

      @if (hasPassword()) {
        <mat-form-field appearance="outline">
          <mat-label>Current password</mat-label>
          <mat-icon matPrefix>lock</mat-icon>
          <input matInput [type]="hidePassword1 ? 'password' : 'text'" formControlName="old_password"
            [attr.maxLength]="limits.name" autocomplete="current-password">
          <button class="password-visibility" mat-icon-button matSuffix type="button"
            (click)="hidePassword1 = !hidePassword1"
            [attr.aria-label]="hidePassword1 ? 'Show current password' : 'Hide current password'">
            <mat-icon>{{ hidePassword1 ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (changePasswordForm.get('old_password')?.hasError('required')) {
            <mat-error>Current password is required</mat-error>
          }
          @if (changePasswordForm.get('old_password')?.hasError('pattern')) {
            <mat-error>Invalid password</mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field appearance="outline">
        <mat-label>New password</mat-label>
        <mat-icon matPrefix>password</mat-icon>
        <input matInput [type]="hidePassword2 ? 'password' : 'text'" formControlName="new_password"
          [attr.maxLength]="limits.name" autocomplete="new-password">
        <button class="password-visibility" mat-icon-button matSuffix type="button"
          (click)="hidePassword2 = !hidePassword2"
          [attr.aria-label]="hidePassword2 ? 'Show new password' : 'Hide new password'">
          <mat-icon>{{ hidePassword2 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (changePasswordForm.get('new_password')?.hasError('required')) {
          <mat-error>New password is required</mat-error>
        }
        @if (changePasswordForm.get('new_password')?.hasError('pattern')) {
          <mat-error>Invalid password</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm password</mat-label>
        <mat-icon matPrefix>verified_user</mat-icon>
        <input matInput [type]="hidePassword3 ? 'password' : 'text'" formControlName="confirm_password"
          [attr.maxLength]="limits.name" autocomplete="new-password">
        <button class="password-visibility" mat-icon-button matSuffix type="button"
          (click)="hidePassword3 = !hidePassword3"
          [attr.aria-label]="hidePassword3 ? 'Show confirmed password' : 'Hide confirmed password'">
          <mat-icon>{{ hidePassword3 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (changePasswordForm.get('confirm_password')?.hasError('required')) {
          <mat-error>Confirm password is required</mat-error>
        }
        @if (changePasswordForm.get('confirm_password')?.hasError('pattern')) {
          <mat-error>Invalid password</mat-error>
        }
        @if (changePasswordForm.get('confirm_password')?.hasError('mismatch')) {
          <mat-error>Passwords do not match</mat-error>
        }
      </mat-form-field>

      <div class="password-guidance">
        <mat-icon>info</mat-icon>
        <div>
          <strong>Keep your account protected</strong>
          <span>Avoid names, common phrases, or passwords already used for another account.</span>
        </div>
      </div>
    </section>
  </form>

  <footer class="password-panel__footer">
    <button class="secondary-btn" mat-flat-button type="button" (click)="cancelClick()">Cancel</button>
    <button class="primary-btn" mat-flat-button type="submit" form="change-password-form"
      [disabled]="isLoading">
      <mat-icon>save</mat-icon>{{ hasPassword() ? 'Update password' : 'Create password' }}
    </button>
  </footer>
</section>
